export enum StopperNamesConstants {
    Bench = "bench",
    Bicycle = "bicycle",
    Gidrant = "gidrant",
    Hatch = "hatch",
    Mail = "mail",
    Menu = "menu",
    Urn = "urn",
}